<app-command [command]="update$" (success)="saved()">
  <app-details-modal
    [title]="title"
    [saveLabel]="saveLabel"
    [form]="formGroup"
    (cancel)="cancel()"
    (save)="save()">
    <app-details-content>
      <ng-container *appLoad="let data of load$; trackingName: 'individual-details'">
        <form [formGroup]="formGroup">
          <!-- details -->
          <section class="mb-md">
            <h4>Personal Details</h4>

            <div class="row" formGroupName="name">
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="title"
                  name="title"
                  label="Title"
                  [options]="
                    data.schema.individual.name.title.options | ldsSelectOption
                  "
                  [isRequired]="
                    data.schema.individual.name.title | standardRequirement
                  "
                  [validations]="{
                    required: 'Title is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-text-input
                  formControlName="first"
                  label="First name"
                  placeholder="first name"
                  [maxlength]="50"
                  [isRequired]="
                    data.schema.individual.name.first | standardRequirement
                  "
                  [validations]="{
                    required: 'First name is required'
                  }">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-text-input
                  formControlName="middle"
                  label="Middle name"
                  placeholder="middle name"
                  [maxlength]="50"
                  [isRequired]="
                    data.schema.individual.name.middle | standardRequirement
                  "
                  [validations]="{
                    required: 'Middle name is required'
                  }">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-text-input
                  formControlName="last"
                  label="Last name"
                  placeholder="last name"
                  [maxlength]="50"
                  [isRequired]="
                    data.schema.individual.name.last | standardRequirement
                  "
                  [validations]="{
                    required: 'Last name is required'
                  }">
                </lds-text-input>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-3" formGroupName="name">
                <lds-text-input
                  formControlName="preferred"
                  label="Preferred name"
                  placeholder="preferred name"
                  [isRequired]="
                    data.schema.individual.name.preferred | standardRequirement
                  "
                  [maxlength]="50"
                  [validations]="{
                    required: 'Preferred name is required'
                  }">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="gender"
                  name="gender"
                  label="Gender"
                  [options]="
                    data.schema.individual.gender.options | ldsSelectOption
                  "
                  [isRequired]="
                    data.schema.individual.gender | standardRequirement
                  "
                  [validations]="{
                    required: 'Gender is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="birthDate"
                  name="birthDate"
                  label="Date of birth"
                  [isRequired]="
                    data.schema.individual.birthDate | standardRequirement
                  "
                  [validations]="{
                    required: 'Date of birth is required',
                    date: 'Must be a valid date',
                    dateBefore: 'Must be a date in the past',
                    ageMin: 'Must be over ' + minAge + ' years',
                    ageMax: 'Must be under ' + maxAge + ' years'
                  }">
                </lds-date-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="status"
                  name="status"
                  label="Status"
                  [options]="
                    data.schema.individual.status.options | ldsSelectOption
                  "
                  [isRequired]="
                    data.schema.individual.status | standardRequirement
                  "
                  [validations]="{
                    required: 'Status is required'
                  }">
                </lds-select>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="contactType"
                  name="contactType"
                  label="Contact type"
                  [isRequired]="
                    data.schema.individual.contactType | standardRequirement
                  "
                  [options]="
                    data.schema.individual.contactType.options | ldsSelectOption
                  "
                  [validations]="{
                    required: 'Contact type is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <spark-shared-yes-or-no-field
                  formControlName="sendMarketingCommunications"
                  identifier="sendMarketingCommunications"
                  label="Send marketing comms."
                  [wrapLabelText]="false"
                  [isRequired]="
                    data.schema.individual.sendMarketingCommunications
                      | standardRequirement
                  ">
                </spark-shared-yes-or-no-field>
              </div>
              <div
                class="col-12 col-sm-6 col-lg-6"
                *ngIf="
                  formGroup.controls.contactType.value | displayAffiliateId
                ">
                <lds-text-input
                  formControlName="nmbAffiliateId"
                  label="Affiliate ID"
                  placeholder="Affiliate ID"
                  [isRequired]="
                    data.schema.individual.nmbAffiliateId | standardRequirement
                  "
                  [maxlength]="100"
                  [validations]="{
                    required: 'Affiliate ID is required'
                  }">
                </lds-text-input>
              </div>
            </div>
          </section>

          <!-- contacts -->
          <section class="mb-md">
            <h4>Contact Details</h4>

            <div class="row" formGroupName="contact">
              <div class="col-12">
                <lds-email-input
                  formControlName="email"
                  label="Email"
                  placeholder="me@example.com"
                  [isRequired]="
                    data.schema.individual.contact.email | standardRequirement
                  "
                  [validations]="{
                    required: 'Email is required',
                    emailAddress: 'Email address must be valid'
                  }">
                </lds-email-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <spark-shared-mobile-number
                  formControlName="mobile"
                  label="Mobile number"
                  [isRequired]="
                    data.schema.individual.contact.mobile | standardRequirement
                  ">
                </spark-shared-mobile-number>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <spark-shared-phone-number
                  formControlName="homePhone"
                  label="Home number"
                  [isRequired]="
                    data.schema.individual.contact.homePhone
                      | standardRequirement
                  ">
                </spark-shared-phone-number>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <spark-shared-phone-number
                  formControlName="workPhone"
                  label="Work number"
                  [isRequired]="
                    data.schema.individual.contact.workPhone
                      | standardRequirement
                  ">
                </spark-shared-phone-number>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-select
                  formControlName="preferredMethod"
                  label="Preferred contact"
                  [options]="
                    data.schema.individual.contact.preferredMethod.options
                      | ldsSelectOption
                  "
                  [isRequired]="
                    data.schema.individual.contact.preferredMethod
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Preferred contact is required'
                  }"
                  [showPlaceholder]="false">
                </lds-select>
              </div>
            </div>
          </section>

          <!-- addresses -->
          <section class="mb-lg">
            <spark-contacts-individual-residences
              formControlName="residences"
              [schema]="data.schema.residences">
            </spark-contacts-individual-residences>
          </section>

          <!-- relationship details -->
          <section class="mb-lg">
            <spark-contacts-individual-relationships
              formControlName="relationships"
              [schema]="data.schema.relationships"
              [contacts]="data.content.contacts">
            </spark-contacts-individual-relationships>
          </section>

          <!-- dependant details -->
          <section class="mb-lg">
            <spark-contacts-individual-dependents
              formControlName="dependents"
              [schema]="data.schema.dependents"
              [contacts]="data.content.contacts">
            </spark-contacts-individual-dependents>
          </section>

          <!-- identification details -->
          <section class="mb-lg" formGroupName="identification">
            <h4>Identification</h4>

            <div class="row" formGroupName="driverLicence">
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-text-input
                  formControlName="number"
                  label="Driver licence"
                  placeholder="licence number"
                  iconPrefix="id-card"
                  [maxlength]="20"
                  [isRequired]="
                    data.schema.individual.identification.driverLicence.number
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Driver licence is required'
                  }">
                </lds-text-input>
              </div>
              <div
                class="col-12 col-sm-6 col-lg-3"
                *ngIf="'mpm' | agpSharedDisableForAggregators">
                <lds-select
                  formControlName="issuer"
                  label="Issuing State"
                  [options]="
                    data.schema.individual.identification.driverLicence.issuer
                      .options | ldsSelectOption
                  "
                  [isRequired]="
                    data.schema.individual.identification.driverLicence.issuer
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Issuing State is required'
                  }">
                </lds-select>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="expiry"
                  label="Expiry date"
                  [validations]="{
                    date: 'Must be a valid date',
                    dateAfter: 'Must be a date in the future'
                  }"
                  [isRequired]="
                    data.schema.individual.identification.driverLicence.expiry
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Expiry date is required'
                  }">
                </lds-date-input>
              </div>
              <div
                class="col-12 col-sm-6 col-lg-3"
                *ngIf="'mpm' | agpSharedDisableForAggregators">
                <lds-select
                  formControlName="type"
                  label="Licence Type"
                  [options]="
                    data.schema.individual.identification.driverLicence.type
                      .options | ldsSelectOption
                  "
                  [isRequired]="
                    data.schema.individual.identification.driverLicence.type
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Licence Type is required'
                  }">
                </lds-select>
              </div>
              <div
                class="col-12 col-sm-12 col-lg-6"
                *ngIf="'mpm' | agpSharedDisableForAggregators">
                <lds-text-input
                  formControlName="cardNumber"
                  label="Licence card number"
                  placeholder="licence card number"
                  iconPrefix="id-card"
                  hint="excluding VIC and QLD"
                  [maxlength]="20">
                </lds-text-input>
              </div>
            </div>
            <div class="row" formGroupName="passport">
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-text-input
                  formControlName="number"
                  label="Passport number"
                  placeholder="passport number"
                  iconPrefix="id-passport"
                  [maxlength]="20"
                  [isRequired]="
                    data.schema.individual.identification.passport.number
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Passport number is required'
                  }">
                </lds-text-input>
              </div>
              <div class="col-12 col-sm-6 col-lg-3">
                <lds-date-input
                  formControlName="expiry"
                  label="Expiry date"
                  [isRequired]="
                    data.schema.individual.identification.passport.expiry
                      | standardRequirement
                  "
                  [validations]="{
                    required: 'Expiry date is required',
                    date: 'Must be a valid date',
                    dateAfter: 'Must be a date in the future'
                  }">
                </lds-date-input>
              </div>
            </div>
          </section>

          <!-- other details -->
          <section>
            <h4>Further Details</h4>

            <div class="row">
              <div class="col-6 col-lg-3">
                <spark-shared-yes-or-no-field
                  formControlName="permanentResident"
                  identifier="permanentResident"
                  label="Permanent resident"
                  [isRequired]="
                    data.schema.individual.permanentResident
                      | standardRequirement
                  ">
                </spark-shared-yes-or-no-field>
              </div>
              <div class="col-6 col-lg-3">
                <spark-shared-yes-or-no-field
                  formControlName="citizen"
                  identifier="citizen"
                  [label]="citizenLabel"
                  [isRequired]="
                    data.schema.individual.citizen | standardRequirement
                  ">
                </spark-shared-yes-or-no-field>
              </div>
              <div class="col-6 col-lg-3">
                <spark-shared-yes-or-no-field
                  formControlName="repayingStudentLoan"
                  identifier="repayingStudentLoan"
                  label="Repaying student loan"
                  [isRequired]="
                    data.schema.individual.repayingStudentLoan
                      | standardRequirement
                  ">
                </spark-shared-yes-or-no-field>
              </div>
            </div>
          </section>

          <section class="mb-lg" *ngIf="!(formGroup.controls.contactType.value | referrerArrangementHidden)">
            <spark-contacts-referrer-arrangement
              formControlName="referrerArrangement"
              [schema]="data.schema.individual.referrerArrangement"
              [isDisabled]="formGroup.controls.nmbAffiliateId.value | referrerArrangementDisabled"
              identifier="individual_referrerArrangement">
            </spark-contacts-referrer-arrangement>
          </section>

          <section class="mt-sm">
            <div class="tags-section">
              <h4>Tags</h4>
              <lds-card>
                <div class="tags-section__details">
                  <app-tag-input
                    [entityId]="isNewEntity ? '' : individualId"
                    [entityType]="tagEntityType"
                    [showLabel]="false"
                    [readonly]="false"
                    (tagsChanged)="onTagsChanged($event)">
                  </app-tag-input>
                </div>
              </lds-card>
            </div>
          </section>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>
